<script>
import { Bar } from "vue-chartjs";

let months = [
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
  "April"
];

export default {
  extends: Bar,
  data() {
    return {
      chartData: {
        labels: months,
        datasets: [
          {
            label: "18K",
            backgroundColor: "#2ECCCC",
            borderWidth: 1,
            data: [811, 910, 604, 743, 815, 469, 0]
          },
          {
            label: "Silver",
            backgroundColor: "#FFCC63",
            borderWidth: 1,
            data: [746, 874, 311, 790, 555, 444, 520]
          }
        ]
      },
      chartOptions: {
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
};
</script>
